import { useState } from 'react';

import { Menu, MenuItem } from '@mui/material';
import { DropdownProps, useDayPicker } from 'react-day-picker';

const CustomDropdown = (props: DropdownProps) => {
  const { classNames, components } = useDayPicker();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!props.disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (!props.disabled && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMenuItemClick = (value: number) => {
    const syntheticEvent = {
      target: { value: value.toString() },
    } as React.ChangeEvent<HTMLSelectElement>;
    props.onChange?.(syntheticEvent);
    handleClose();
  };

  return (
    <span
      className={classNames.dropdown_root}
      data-disabled={props.disabled ? 'true' : 'false'}
    >
      <span
        className={classNames.caption_label}
        aria-label={props['aria-label']}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        tabIndex={props.disabled ? -1 : 0}
        role='button'
        aria-haspopup='true'
        aria-expanded={open}
        style={{ cursor: props.disabled ? 'default' : 'pointer' }}
      >
        {props.options?.find((o) => o.value === props.value)?.label}
        <components.Chevron
          className={classNames.chevron}
          orientation='down'
          size={18}
        />
      </span>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disablePortal
        slotProps={{
          paper: {
            sx: {
              maxHeight: 300,
            },
          },
          list: {
            'aria-label': props['aria-label'],
          },
        }}
      >
        {props.options?.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            selected={option.value === props.value}
            onClick={() => {
              handleMenuItemClick(option.value);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </span>
  );
};

export default CustomDropdown;
